export default __webpack_public_path__ + "static/media/happets1.a8e638e4.png";